(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);


// Touch

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}


// Menu hover
/*
if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details:not(.shop-by-brand):not(.links)");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 100);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}
*/

// Menu Expand
/*
document.querySelectorAll(".header__subdropdown > div > ul > li").forEach(function(element){
  element.addEventListener("click", function(event){

    //console.log('test')

    document.querySelectorAll(".header__subdropdown > div > ul > li details:not(.shop-by-brand):not(.links)").forEach(function(element){
      element.removeAttribute("open");
    });

  });
});
*/


// USP Slider

var uspSlider = document.querySelectorAll('.usp-wrapper');
if ( uspSlider ){
  uspSlider.forEach(slider => {
    var flkty = new Flickity( slider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      autoPlay: 3000,
      watchCSS: true,
      pauseAutoPlayOnHover: false
    });
  });
}


// Footer Map Buttons

var mapBtns = document.querySelectorAll('.map-btn');
var mapClose = document.querySelectorAll('.map-close');

mapBtns.forEach(btn => {

  btn.addEventListener("click", function(event){
    var getMap = this.parentNode.previousElementSibling;
    getMap.classList.add("open");
    document.getElementsByTagName('body')[0].classList.add("overflow");
  });

});

mapClose.forEach(btn => {
  btn.addEventListener("click", function(event){
    document.getElementsByTagName('body')[0].classList.remove("overflow");
    document.querySelector('.footer-block__details-map.open').classList.remove("open");
  });
});


// Scroll Up

var scrollTopBtn = document.getElementById('scroll-top');

if ( window.scrollY > 0 ){
  scrollTopBtn.classList.remove('hide');
}

scrollTopBtn.addEventListener("click", function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(function(){
    scrollTopBtn.classList.add('hide');
  }, 500);
});


var scrollableElement = window;

scrollableElement.addEventListener('scroll', checkScroll);

function checkScroll(event) {
    console.log('scroll');
    scrollTopBtn.classList.remove('hide');

    if ( window.scrollY === 0 ){
      scrollTopBtn.classList.add('hide');
    }
}


// Related Slider
/*
ready('#related-product-grid .grid__item', function(element) {
  var relatedSlider = document.getElementById('related-product-grid');
  if ( relatedSlider ){
    var flkty = new Flickity( relatedSlider, {
      // options
      groupCells: true,
      cellAlign: 'left',
      //contain: true,
      wrapAround: false,
      pageDots: false,
      pauseAutoPlayOnHover: false
    });
  }
});
*/


// Move Wishlist

ready('.product__info-wrapper .wishlist-engine', function(element) {

  // Get the DOM nodes
  let productwishlist = document.querySelector('.product__info-wrapper .wishlist-engine');
  let productForm = document.querySelector('.product__info-wrapper .product-form');

  if ( productwishlist && productForm ){
    // Move stuff
    productForm.after(productwishlist);
  }
  
});


// Move Paypal - Product

ready('#paypal-upstream-messaging-product', function(element) {

  // Get the DOM nodes
  let payLater = document.querySelector('#paypal-upstream-messaging-product');
  let paypalWrapper = document.querySelector('.paypal-wrapper');

  if ( payLater && paypalWrapper ){
    // Move stuff
    paypalWrapper.prepend(payLater);
  }
  
});


// Move Paypal - Cart

ready('#paypal-upstream-messaging-cart-page', function(element) {

  // Get the DOM nodes
  let payLaterCart = document.querySelector('#paypal-upstream-messaging-cart-page');
  let cartBlock = document.querySelector('.cart__blocks #cart-errors');

  if ( cartBlock && payLaterCart ){
    // Move stuff
    cartBlock.before(payLaterCart);
  }
  
});